import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/brands/treasure/canvas/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/brands/treasure/canvas/glove/back/ringFinger'
import { thumbEmbroideryDrawer } from 'src/features/brands/treasure/canvas/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndListBelt, thumbOut, thumbOverParts } from '../thumbAndListBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from '../edge/edgeOfWrist'
import { edgeOfThumbOverBackStyle } from '../edge/thumbOver'
import { treasureOriginal } from '../treasureOriginal'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'
import { aplSeriesChecker } from 'src/features/brands/atoms/helper'

// 通常ベルトモデル
export const beltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const isThumbOverBelt = 'thumbOver' === state.beltType?.value

  if (!isThumbOverBelt) {
    thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
    thumbOut(ctx, state.thumbOut?.color) // 親指＿外
  }

  // 人差し指＿右... UBackここで描いてる
  indexFingerRight(
    ctx,
    state,
    // needCatchFaceWrap ? state.indexWeb?.color : state?.thumbWebAndIndexWeb?.color,
    // state.catchFace.color,
    // state.hamidashi.color,
    needCatchFaceWrap
  )
  const isBelt = ['normal', 'unselected', undefined].includes(state.beltType?.value)
  if (isBelt) {
    listBelt(ctx, state.listBelt?.color, state.stitch?.color)
  }

  if (['treasureOriginal'].includes(state.beltType?.value)) {
    treasureOriginal(ctx, state?.treasureOriginalParts?.color, state.thumbWeb.color, state.stitch.color)
  }
  // 人差し指＿左
  indexFingerLeft(ctx, state.indexMiddle?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.middleRing?.color)
  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  if (!isThumbOverBelt) {
    hamidashiOfNormal(ctx, state.hamidashi?.color)
  }

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)
  // ヘリ革
  if (!isThumbOverBelt) {
    // thumbOverではなかったら
    edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
    edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)
  }
  if (['thumbOver'].includes(state.beltType?.value)) {
    // ベルト部分のパーツ
    ctx.fillStyle = state.listBelt.color
    ctx.strokeStyle = '#282828'
    ctx.beginPath()
    ctx.moveTo(291, 490) // ベルト左上
    ctx.quadraticCurveTo(319, 538, 340, 588) // ベルト左下
    ctx.quadraticCurveTo(428, 599, 528, 586) // ベルト右下
    ctx.quadraticCurveTo(491, 456, 491, 456) // ベルト右上
    ctx.quadraticCurveTo(291, 490, 291, 490) // ベルト左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
    edgeOfWrist(ctx, state.edge.color, state.stitch.color)
    thumbOverParts(ctx, state.thumbWeb?.color)
    edgeOfThumbOverBackStyle(ctx, state.edge.color, state.stitch.color)
    // 親指＿外
    thumbOut(ctx, state.thumbOut.color)
    // ハミダシ
    hamidashiOfNormal(ctx, state.hamidashi.color)
  }
  // 指当て(人指し指)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指当て(中指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  // 指股
  if (state?.backStyle?.value !== 'crownBackStyle') {
    fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)
  }

  thumbEmbroideryDrawer(ctx, state.embroideries)
}
